function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.75 19.375H27.8571V16.25C27.8571 12.8031 24.6536 10 20.7143 10C16.775 10 13.5714 12.8031 13.5714 16.25V19.375H12.6786C11.2024 19.375 10 20.426 10 21.7188V32.6562C10 33.949 11.2024 35 12.6786 35H28.75C30.2262 35 31.4286 33.949 31.4286 32.6562V21.7188C31.4286 20.426 30.2262 19.375 28.75 19.375ZM15.9524 16.25C15.9524 13.9521 18.0881 12.0833 20.7143 12.0833C23.3405 12.0833 25.4762 13.9521 25.4762 16.25V19.375H15.9524V16.25ZM21.9048 27.4187V29.7917C21.9048 30.3667 21.3726 30.8333 20.7143 30.8333C20.056 30.8333 19.5238 30.3667 19.5238 29.7917V27.4187C18.8155 27.0573 18.3333 26.3927 18.3333 25.625C18.3333 24.476 19.4012 23.5417 20.7143 23.5417C22.0274 23.5417 23.0952 24.476 23.0952 25.625C23.0952 26.3927 22.6131 27.0573 21.9048 27.4187Z",
  fill: "white"
});
function SvgPadlockIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockIco);
export default __webpack_public_path__ + "static/media/padlock_ico.ba4eeed1d9b46380b97ab5b04aeeb5f9.svg";
export { ForwardRef as ReactComponent };